export default __webpack_public_path__ + "static/mopSopped-63ac37878de350d5495a0f730ed1ff8b.svg";